export const ACTIVE_VERTICAL = 'vertical';
export const AIRPORTS = 'airports';
export const ALLIANCES = 'alliances';
export const ALT_DATES_REDIRECT = 'altDatesRedirect';
export const BOUNCED_FROM_CHECKOUT = 'bfc';
export const CARRIERS = 'airlines';
export const DEPARTURE_TIMES = 'departure-times';
export const DESTINATION_ENTITY_ID = 'destinationentityid';
export const DURATION = 'duration';
export const GREENER_CHOICES = 'greener-choices';
export const PREFER_DIRECTS = 'preferdirects';
export const SORT_BY = 'sortby';
export const SPONSORED_AGENT = 'sponsoredagent';
export const SPONSORED_PREVIEW_ID = 'sponsoredPreviewId';
export const STOPS = 'stops';
export const FARE_ATTRIBUTES = 'fare-attributes';
export const LAYOVER_AIRPORTS = 'layover-airports';
export const LAYOVER_DURATION = 'layover-duration';

export const PERSISTED_QUERY_PARAMS = [
  CARRIERS,
  ALLIANCES,
  ALT_DATES_REDIRECT,
  DEPARTURE_TIMES,
  DURATION,
  GREENER_CHOICES,
  LAYOVER_AIRPORTS,
  LAYOVER_DURATION,
  SPONSORED_AGENT,
  STOPS,
  FARE_ATTRIBUTES,
];

export const RANGE_DELIMITER = '-';
export const DELIMITER = ',';
export const NOT_SYMBOL = '!';
